import { render, staticRenderFns } from "./CoursesPanel.vue?vue&type=template&id=03289f3a&scoped=true"
import script from "./CoursesPanel.vue?vue&type=script&lang=js"
export * from "./CoursesPanel.vue?vue&type=script&lang=js"
import style0 from "./CoursesPanel.vue?vue&type=style&index=0&id=03289f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03289f3a",
  null
  
)

export default component.exports